module.exports = __webpack_public_path__ + "static/media/withGates.8eacf31e.jpg";